import type { PlayerTransactionReceiptResponse } from "@bw/shared/types/generated";

function humanType(type: string): string {
  return type
    .split("_")
    .map((part) => (part ? part[0].toUpperCase() + part.slice(1) : part))
    .join(" ");
}

/** Defensive display copy; identifiers stay in links and API state, not text. */
export function transactionLabel(transaction: PlayerTransactionReceiptResponse): string {
  const description = transaction.description?.trim();
  if (!description) return humanType(transaction.type);

  const identifiers = [
    transaction.transaction_id,
  ].filter((value): value is string => Boolean(value));
  if (identifiers.some((value) => description.includes(value))) {
    return humanType(transaction.type);
  }
  if (
    /\b(?:pi|evt|re|ch|cs|sub|in|acct)_[A-Za-z0-9_]+\b/i.test(description) ||
    /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i.test(description) ||
    /(?:^|[\s-])(?:reference|secret)(?:[:\s-]|$)/i.test(description)
  ) {
    return humanType(transaction.type);
  }
  return description;
}
